import {createApp} from 'vue/dist/vue.esm-bundler'
import DoorSearch from './DoorSearch.vue';

const initDoorSearch = () => {
  createApp(DoorSearch)
    .mount('.door-search-widget');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initDoorSearch();
  })
} else {
  initDoorSearch();
}